function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 507.9 507.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M329.65,447.9c-6.3,0-11.9-4.2-13.5-10.4l-11.3-41.5h-101.8l-11.2,41.5c-1.7,6.1-7.2,10.4-13.5,10.4 h-59.8l-7.5,32.1h286l-7.5-32.1H329.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M29.55,353.9c0,7.7,6.3,14,14,14h318.7v-9.1c0-7.7,6.3-14,14-14s14,6.3,14,14v9.1h25.7v-9.1 c0-7.7,6.3-14,14-14s14,6.3,14,14v9.1h20.3c7.7,0,14-6.3,14-14V323H29.55V353.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M478.35,42.1c0-7.7-6.3-14-14-14H43.55c-7.7,0-14,6.3-14,14v252.8h448.9V42.1H478.35z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M422.25,56.1H85.65c-11.3,0-21,6.8-25.5,16.4h53c7.7,0,14,6.3,14,14s-6.3,14-14,14h-55.6v31.1h23.6 c7.7,0,14,6.3,14,14s-6.3,14-14,14h-23.6v135.2h392.8V84.2C450.35,68.7,437.75,56.1,422.25,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M298.05,220.3l12.5-22.2c5-8.5,15.3-9.8,22.1-3l30.6,30.6l16-16l-30.6-30.6c-6.8-7.3-5.5-17.3,3-22.1 l22.2-12.5l-117.2-41.3L298.05,220.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M412.45,128.3l-174-61.4c-10.6-3.3-21.3,5.7-17.9,17.9l61.4,174c4.2,10.6,17.9,13.5,25.5,2.2 l18.5-33l27.5,27.5c6.2,5.6,14,5.6,19.8,0l35.8-35.8c5.5-5.5,5.5-14.4,0-19.8l-27.5-27.5l33.1-18.6 C425.35,147.9,423.65,132.9,412.45,128.3z M351.65,157c-8.5,4.8-9.8,14.8-3,22.1l30.6,30.6l-16,16l-30.6-30.6 c-6.8-6.8-17.1-5.4-22.1,3l-12.5,22.2l-41.3-117.2l117.2,41.4L351.65,157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M464.35,0H43.55c-23.2,0-42.1,18.9-42.1,42.1v311.8c0,23.2,18.9,42.1,42.1,42.1h130.4l-6.4,23.8 h-60.2c-6.5,0-12.2,4.5-13.7,10.8l-14,60.1c-1,4.2,0,8.5,2.7,11.9s6.7,5.3,11,5.3h321.4c4.3,0,8.3-2,11-5.3 c2.7-3.4,3.6-7.7,2.7-11.9l-14-60.1c-1.5-6.3-7.1-10.8-13.7-10.8h-60.2l-6.6-23.8h130.4c23.2,0,42.1-18.9,42.1-42.1V42.1 C506.45,18.9,487.55,0,464.35,0z M389.45,447.9l7.5,32.1h-286l7.5-32.1h59.8c6.3,0,11.9-4.2,13.5-10.4l11.2-41.5h101.9l11.2,41.5 c1.7,6.1,7.2,10.4,13.5,10.4H389.45z M478.35,353.9c0,7.7-6.3,14-14,14h-20.3v-9.1c0-7.7-6.3-14-14-14s-14,6.3-14,14v9.1h-25.7 v-9.1c0-7.7-6.3-14-14-14s-14,6.3-14,14v9.1H43.55c-7.7,0-14-6.3-14-14V323h448.9v30.9H478.35z M478.35,294.9H29.55V42.1 c0-7.7,6.3-14,14-14h420.8c7.7,0,14,6.3,14,14V294.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTry);
export default __webpack_public_path__ + "static/media/Try.7631cc0c.svg";
export { ForwardRef as ReactComponent };